import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var BannerButtonsInlineStyles = /*#__PURE__*/function () {
  function BannerButtonsInlineStyles() {
    _classCallCheck(this, BannerButtonsInlineStyles);
  }

  _createClass(BannerButtonsInlineStyles, null, [{
    key: "acceptAll",
    value: function acceptAll(_ref, isHover, framed, isTwoButtonRowLayout) {
      var _acceptAll = _ref.decision.acceptAll,
          borderRadius = _ref.layout.borderRadius,
          linkTextDecoration = _ref.design.linkTextDecoration,
          _ref$bodyDesign = _ref.bodyDesign,
          acceptAllFontSize = _ref$bodyDesign.acceptAllFontSize,
          acceptAllBg = _ref$bodyDesign.acceptAllBg,
          acceptAllTextAlign = _ref$bodyDesign.acceptAllTextAlign,
          acceptAllBorderColor = _ref$bodyDesign.acceptAllBorderColor,
          acceptAllPadding = _ref$bodyDesign.acceptAllPadding,
          acceptAllBorderWidth = _ref$bodyDesign.acceptAllBorderWidth,
          acceptAllFontColor = _ref$bodyDesign.acceptAllFontColor,
          acceptAllFontWeight = _ref$bodyDesign.acceptAllFontWeight,
          acceptAllHoverBg = _ref$bodyDesign.acceptAllHoverBg,
          acceptAllHoverFontColor = _ref$bodyDesign.acceptAllHoverFontColor,
          acceptAllHoverBorderColor = _ref$bodyDesign.acceptAllHoverBorderColor,
          antiAdBlocker = _ref.customCss.antiAdBlocker;
      return this.common({
        name: "accept-all",
        order: isTwoButtonRowLayout ? 1 : 0,
        fullWidth: !isTwoButtonRowLayout,
        marginLeft: isTwoButtonRowLayout ? 5 : 0,
        marginRight: 0,
        type: _acceptAll,
        borderRadius: borderRadius,
        bg: acceptAllBg,
        hoverBg: acceptAllHoverBg,
        fontSize: acceptAllFontSize,
        textAlign: acceptAllTextAlign,
        linkTextDecoration: linkTextDecoration,
        fontColor: acceptAllFontColor,
        fontWeight: acceptAllFontWeight,
        hoverFontColor: acceptAllHoverFontColor,
        borderWidth: acceptAllBorderWidth,
        borderColor: acceptAllBorderColor,
        hoverBorderColor: acceptAllHoverBorderColor,
        padding: acceptAllPadding,
        antiAdBlocker: antiAdBlocker
      }, isHover, framed);
    }
  }, {
    key: "acceptEssentials",
    value: function acceptEssentials(_ref2, isHover, framed, isTwoButtonRowLayout) {
      var isTcf = _ref2.isTcf,
          _acceptEssentials = _ref2.decision.acceptEssentials,
          borderRadius = _ref2.layout.borderRadius,
          linkTextDecoration = _ref2.design.linkTextDecoration,
          _ref2$bodyDesign = _ref2.bodyDesign,
          acceptEssentialsFontSize = _ref2$bodyDesign.acceptEssentialsFontSize,
          acceptEssentialsBg = _ref2$bodyDesign.acceptEssentialsBg,
          acceptEssentialsTextAlign = _ref2$bodyDesign.acceptEssentialsTextAlign,
          acceptEssentialsBorderColor = _ref2$bodyDesign.acceptEssentialsBorderColor,
          acceptEssentialsPadding = _ref2$bodyDesign.acceptEssentialsPadding,
          acceptEssentialsBorderWidth = _ref2$bodyDesign.acceptEssentialsBorderWidth,
          acceptEssentialsFontColor = _ref2$bodyDesign.acceptEssentialsFontColor,
          acceptEssentialsFontWeight = _ref2$bodyDesign.acceptEssentialsFontWeight,
          acceptEssentialsHoverBg = _ref2$bodyDesign.acceptEssentialsHoverBg,
          acceptEssentialsHoverFontColor = _ref2$bodyDesign.acceptEssentialsHoverFontColor,
          acceptEssentialsHoverBorderColor = _ref2$bodyDesign.acceptEssentialsHoverBorderColor,
          acceptAllFontWeight = _ref2$bodyDesign.acceptAllFontWeight,
          acceptAllFontSize = _ref2$bodyDesign.acceptAllFontSize,
          acceptAllPadding = _ref2$bodyDesign.acceptAllPadding,
          antiAdBlocker = _ref2.customCss.antiAdBlocker;
      return this.common({
        name: "accept-essentials",
        order: isTwoButtonRowLayout ? 0 : 1,
        fullWidth: !isTwoButtonRowLayout,
        marginLeft: 0,
        marginRight: isTwoButtonRowLayout ? 5 : 0,
        type: _acceptEssentials,
        borderRadius: borderRadius,
        bg: acceptEssentialsBg,
        hoverBg: acceptEssentialsHoverBg,
        fontSize: isTwoButtonRowLayout || isTcf ? acceptAllFontSize : acceptEssentialsFontSize,
        textAlign: acceptEssentialsTextAlign,
        linkTextDecoration: linkTextDecoration,
        fontColor: acceptEssentialsFontColor,
        fontWeight: isTcf ? acceptAllFontWeight : acceptEssentialsFontWeight,
        hoverFontColor: acceptEssentialsHoverFontColor,
        borderWidth: acceptEssentialsBorderWidth,
        borderColor: acceptEssentialsBorderColor,
        hoverBorderColor: acceptEssentialsHoverBorderColor,
        padding: isTwoButtonRowLayout ? acceptAllPadding : acceptEssentialsPadding,
        antiAdBlocker: antiAdBlocker
      }, isHover, framed);
    }
  }, {
    key: "acceptIndividual",
    value: function acceptIndividual(_ref3, isHover, framed) {
      var _acceptIndividual = _ref3.decision.acceptIndividual,
          borderRadius = _ref3.layout.borderRadius,
          linkTextDecoration = _ref3.design.linkTextDecoration,
          _ref3$bodyDesign = _ref3.bodyDesign,
          acceptIndividualFontSize = _ref3$bodyDesign.acceptIndividualFontSize,
          acceptIndividualBg = _ref3$bodyDesign.acceptIndividualBg,
          acceptIndividualTextAlign = _ref3$bodyDesign.acceptIndividualTextAlign,
          acceptIndividualBorderColor = _ref3$bodyDesign.acceptIndividualBorderColor,
          acceptIndividualPadding = _ref3$bodyDesign.acceptIndividualPadding,
          acceptIndividualBorderWidth = _ref3$bodyDesign.acceptIndividualBorderWidth,
          acceptIndividualFontColor = _ref3$bodyDesign.acceptIndividualFontColor,
          acceptIndividualFontWeight = _ref3$bodyDesign.acceptIndividualFontWeight,
          acceptIndividualHoverBg = _ref3$bodyDesign.acceptIndividualHoverBg,
          acceptIndividualHoverFontColor = _ref3$bodyDesign.acceptIndividualHoverFontColor,
          acceptIndividualHoverBorderColor = _ref3$bodyDesign.acceptIndividualHoverBorderColor,
          antiAdBlocker = _ref3.customCss.antiAdBlocker;
      return this.common({
        name: "accept-individual",
        order: 2,
        fullWidth: true,
        marginLeft: 0,
        marginRight: 0,
        type: _acceptIndividual,
        borderRadius: borderRadius,
        bg: acceptIndividualBg,
        hoverBg: acceptIndividualHoverBg,
        fontSize: acceptIndividualFontSize,
        textAlign: acceptIndividualTextAlign,
        linkTextDecoration: linkTextDecoration,
        fontColor: acceptIndividualFontColor,
        fontWeight: acceptIndividualFontWeight,
        hoverFontColor: acceptIndividualHoverFontColor,
        borderWidth: acceptIndividualBorderWidth,
        borderColor: acceptIndividualBorderColor,
        hoverBorderColor: acceptIndividualHoverBorderColor,
        padding: acceptIndividualPadding,
        antiAdBlocker: antiAdBlocker
      }, isHover, framed);
    }
  }, {
    key: "save",
    value: function save(_ref4, isHover, framed) {
      var isTcf = _ref4.isTcf,
          borderRadius = _ref4.layout.borderRadius,
          linkTextDecoration = _ref4.design.linkTextDecoration,
          _ref4$bodyDesign = _ref4.bodyDesign,
          acceptAllFontWeight = _ref4$bodyDesign.acceptAllFontWeight,
          acceptAllFontSize = _ref4$bodyDesign.acceptAllFontSize,
          _ref4$saveButton = _ref4.saveButton,
          type = _ref4$saveButton.type,
          fontSize = _ref4$saveButton.fontSize,
          bg = _ref4$saveButton.bg,
          textAlign = _ref4$saveButton.textAlign,
          borderColor = _ref4$saveButton.borderColor,
          padding = _ref4$saveButton.padding,
          borderWidth = _ref4$saveButton.borderWidth,
          fontColor = _ref4$saveButton.fontColor,
          fontWeight = _ref4$saveButton.fontWeight,
          hoverBg = _ref4$saveButton.hoverBg,
          hoverFontColor = _ref4$saveButton.hoverFontColor,
          hoverBorderColor = _ref4$saveButton.hoverBorderColor,
          antiAdBlocker = _ref4.customCss.antiAdBlocker;
      return this.common({
        name: "accept-individual-save",
        order: 2,
        fullWidth: true,
        marginLeft: 0,
        marginRight: 0,
        type: type,
        borderRadius: borderRadius,
        bg: bg,
        hoverBg: hoverBg,
        fontSize: isTcf ? acceptAllFontSize : fontSize,
        textAlign: textAlign,
        linkTextDecoration: linkTextDecoration,
        fontColor: fontColor,
        fontWeight: isTcf ? acceptAllFontWeight : fontWeight,
        hoverFontColor: hoverFontColor,
        borderWidth: borderWidth,
        borderColor: borderColor,
        hoverBorderColor: hoverBorderColor,
        padding: padding,
        antiAdBlocker: antiAdBlocker
      }, isHover, framed);
    }
  }, {
    key: "ellipsesText",
    value: function ellipsesText() {
      return {
        style: {
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          wordBreak: "keep-all",
          overflow: "hidden",
          cursor: "pointer"
        }
      };
    }
  }, {
    key: "common",
    value: function common(_ref5, isHover, framed) {
      var name = _ref5.name,
          order = _ref5.order,
          fullWidth = _ref5.fullWidth,
          marginLeft = _ref5.marginLeft,
          marginRight = _ref5.marginRight,
          type = _ref5.type,
          borderRadius = _ref5.borderRadius,
          bg = _ref5.bg,
          hoverBg = _ref5.hoverBg,
          fontSize = _ref5.fontSize,
          textAlign = _ref5.textAlign,
          linkTextDecoration = _ref5.linkTextDecoration,
          fontColor = _ref5.fontColor,
          fontWeight = _ref5.fontWeight,
          hoverFontColor = _ref5.hoverFontColor,
          borderWidth = _ref5.borderWidth,
          borderColor = _ref5.borderColor,
          hoverBorderColor = _ref5.hoverBorderColor,
          padding = _ref5.padding,
          antiAdBlocker = _ref5.antiAdBlocker;
      var style = {
        textDecoration: type === "link" ? linkTextDecoration : "none",
        borderRadius: +borderRadius,
        cursor: type === "button" ? "pointer" : undefined,
        backgroundColor: type === "button" ? isHover ? hoverBg : bg : undefined,
        fontSize: +fontSize,
        fontWeight: fontWeight,
        color: isHover ? hoverFontColor : fontColor,
        transition: "background-color 250ms, color 250ms, border-color 250ms",
        margin: "0 ".concat(marginRight, "px 10px ").concat(marginLeft, "px"),
        border: type === "button" && borderWidth > 0 ? "".concat(borderWidth, "px solid ").concat(isHover ? hoverBorderColor : borderColor) : undefined,
        padding: padding.map(function (p) {
          return "".concat(p, "px");
        }).join(" "),
        overflow: "hidden",
        outline: framed ? "rgb(255, 94, 94) solid 5px" : undefined,
        flex: fullWidth ? "1 1 100%" : "0 0 calc(50% - ".concat(marginLeft + marginRight, "px)"),
        display: "flex",
        alignItems: "center",
        // text-align is not supported within a `display: flex`
        justifyContent: textAlign === "right" ? "flex-end" : textAlign === "center" ? "center" : "left",
        order: order
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-btn-".concat(name),
        style: style
      };
    }
  }]);

  return BannerButtonsInlineStyles;
}();

export { BannerButtonsInlineStyles };